import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Sparkles, Heart } from "lucide-react";
import { FILE_URL, formatBRL, displayBrand } from "../lib/api";
import { useWishlist } from "../context/WishlistContext";
import { useAuth } from "../context/AuthContext";
import LoginPromptModal from "./LoginPromptModal";

const FALLBACK_IMG = "https://images.unsplash.com/photo-1611652022419-a9419f74343d?crop=entropy&cs=srgb&fm=jpg&q=85&w=800";

export default function ProductCard({ product }) {
  const { toggle, has } = useWishlist();
  const { user } = useAuth();
  const nav = useNavigate();
  const [promptOpen, setPromptOpen] = useState(false);
  const img = product.images?.[0] ? FILE_URL(product.images[0]) : FALLBACK_IMG;
  const isFav = has(product.id);
  const tryOnTarget = `/try-on/experimentar?produto=${product.id}`;

  const goToTryOn = (e) => {
    e.preventDefault();
    if (!user) {
      setPromptOpen(true);
      return;
    }
    nav(tryOnTarget);
  };

  return (
    <div className="group relative" data-testid={`product-card-${product.id}`}>
      <Link to={`/produto/${product.id}`} className="block overflow-hidden bg-[#FAF9F7]">
        <div className="aspect-[3/4] overflow-hidden">
          <img
            src={img}
            alt={product.name}
            className="w-full h-full object-cover img-hover"
            loading="lazy"
          />
        </div>
      </Link>

      {(product.is_unique || product.status === "unique") && (
        <span className="absolute top-3 left-3 bg-[#F5EFE8] text-[#1A1A1A] text-[10px] uppercase tracking-wider px-2.5 py-1 font-medium">
          Peça Única
        </span>
      )}
      {product.is_new && (
        <span className="absolute top-3 right-3 bg-[#1A1A1A] text-white text-[10px] uppercase tracking-wider px-2.5 py-1">
          New
        </span>
      )}

      {/* hover actions */}
      <div className="absolute bottom-3 right-3 flex flex-col gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
        <button
          data-testid={`fav-btn-${product.id}`}
          onClick={(e) => { e.preventDefault(); toggle(product); }}
          className={`w-9 h-9 flex items-center justify-center bg-white shadow-sm transition-colors ${isFav ? "text-[#B8A88A]" : "text-[#1A1A1A]"}`}
          aria-label="Favoritar"
        >
          <Heart size={14} fill={isFav ? "#B8A88A" : "none"} />
        </button>
        <Link
          data-testid={`tryon-btn-${product.id}`}
          to={`/try-on?produto=${product.id}`}
          onClick={goToTryOn}
          className="w-9 h-9 flex items-center justify-center bg-[#B8A88A] text-white"
          aria-label="Experimentar"
        >
          <Sparkles size={14} />
        </Link>
      </div>

      <div className="mt-4 px-1">
        {(() => {
          const brand = displayBrand(product);
          return brand
            ? <p className="text-[10px] uppercase tracking-wider text-[#A8A8A8] mb-1">{brand}</p>
            : null;
        })()}
        <Link to={`/produto/${product.id}`}>
          <h3 className="font-display text-lg leading-tight mb-1 hover:text-[#B8A88A] transition-colors">
            {product.name}
          </h3>
        </Link>
        <p className="text-sm text-[#1A1A1A]">{formatBRL(product.price)}</p>
      </div>
      <LoginPromptModal open={promptOpen} onClose={() => setPromptOpen(false)} redirectTo={tryOnTarget} />
    </div>
  );
}
